import api from "@/lib/api";
import { logDev } from "@/lib/log";

export const trackContent = (kind, id, action) =>
  api.post(`/content/${kind}/${id}/track`, { action }).catch(logDev);
